import { isEntityInfantry } from "./entityTypeMetaList.generated"

const canEntityAnnexInGeneral = isEntityInfantry

export default canEntityAnnexInGeneral